/**
 * File banner-carousel.js
 *
 * Handles Swiper Carousels for the homepage banner.
 */

// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/no-unresolved */
//import Swiper
import Swiper from 'swiper/bundle';

// import Swiper styles
import 'swiper/css/bundle';

document.addEventListener( 'DOMContentLoaded', function () {
	new Swiper( '.hero-carousel', {
		slidesPerView: 'auto',
		spaceBetween: 0,
		centeredSlides: true,
		centerMode: true,
		speed: 1500,
		autoplay: {
			delay: 6000,
		},
		loop: true,
		keyboard: {
			enabled: true,
			onlyInViewport: true,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	} );

	new Swiper( '.gallery-carousel', {
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			draggable: true,
		},
	} );

	new Swiper( '.interactive', {
		spaceBetween: 0,
		loop: false,
		slidesPerView: 1,
		slidesToScroll: 1,
		cssMode: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
			1280: {
				slidesPerView: 4,
			},
		},
	} );
} );
